import React from 'react'
import { Button } from 'react-bootstrap'
import { MdModeEditOutline } from 'react-icons/md'
import TaggedPerson from './TaggedPerson'
import TextItemTittle from './TextItemTittle'
import YoutubeUrlComponent from './YoutubeUrlComponent'
import './list.css'

function SelectedMoviePersonUi(props) {
  const {
    selectedMovieOrPersonData,
    selectedListType,
    changelistItemTitle,
    editIndexes,
    getFormattedImage,
    uploadImage,
    removeImage,
    handleChangeDescription,
    handleDelete,
    handleMoveItem,
    EditVideo,
    removeVideo,
    getURl,
    PushVideo,
    handleEdit,
    editMode,
    allTaggedPersons,
    // addOrRemoveTaggedPerson,
    sendTaggedPersons,
    setvalueEdited,
    requiredImageSize,
  } = props

  const moveItemDown = dataIndex => {
    handleMoveItem('down', dataIndex)
    setvalueEdited(true)
  }

  const moveItemUp = dataIndex => {
    handleMoveItem('up', dataIndex)
    setvalueEdited(true)
  }

  const DeleteItem = dataIndex => {
    handleDelete(dataIndex)
    setvalueEdited(true)
  }

  const handleChangeInDescription = (value, obj) => {
    handleChangeDescription(value, obj)
    setvalueEdited(true)
  }

  return (
    <>
      {selectedMovieOrPersonData.map((dataItem, dataIndex) => (
        <div style={{ width: '100%' }} key={dataIndex}>
          <TextItemTittle
            selectedListType={selectedListType}
            dataItem={dataItem}
            changelistItemTitle={changelistItemTitle}
            dataIndex={dataIndex}
            editIndexes={editIndexes}
            setvalueEdited={setvalueEdited}
          />
          <div className='d-flex justify-content-between mt-2 mb-2' style={{ width: '100%' }}>
            <div className='d-flex ' style={{ width: '100%' }}>
              {selectedListType !== 'Text' && (
                <div
                  className='moviePoster mr-1'
                  style={{ height: '12rem', width: '12rem', objectFit: 'cover' }}
                >
                  <label> {selectedListType}Image:</label>
                  <img
                    style={{ height: '100%', width: '100%' }}
                    src={getFormattedImage(dataItem.posterURL)}
                  />
                </div>
              )}
              {selectedListType === 'Text' && (
                <div
                  className='moviePoster mr-1'
                  style={{ height: '12rem', width: '12rem', objectFit: 'cover' }}
                >
                  <label> {selectedListType}Image:</label>
                  {!(dataItem && dataItem.listItemImage) && (
                    <div className='imagecontainer'>
                      <label className='imagelabelposition'>
                        Upload Image
                        <input
                          type='file'
                          style={{ display: 'none' }}
                          // className='btn btn-primary'
                          accept='image/*'
                          disabled={!editIndexes.includes(dataItem.SK)}
                          onChange={e => uploadImage(e, dataIndex)}
                        ></input>
                      </label>
                    </div>
                  )}
                  {dataItem && (dataItem.posterURL || dataItem.listItemImage) && (
                    <div style={{ height: '100%', width: '100%', display: 'flex' }}>
                      <div style={{ height: '100%', width: '120%' }}>
                        <img
                          style={{ height: '100%', width: '100%' }}
                          src={getFormattedImage(dataItem.listItemImage)}
                        />
                      </div>
                      <div className='textposter'>
                        <button
                          className='btn btn-danger'
                          style={{ padding: '0.2rem' }}
                          onClick={() => removeImage(dataIndex)}
                          disabled={!editIndexes.includes(dataItem.SK)}
                        >
                          X
                        </button>
                      </div>
                    </div>
                  )}
                  {requiredImageSize[dataIndex] ? <span className='mandatory1'>ImageSize should not be more than 1mb </span> : ''}
                </div>
              )}

              {['En', 'Te'].map((lang, languageIndex) => (
                <div key={languageIndex}>
                  <label>List Item Description_{lang}:</label>
                  <textarea
                    disabled={!editIndexes.includes(dataItem.SK)}
                    className='rounded'
                    style={{ width: '80%' }}
                    onChange={e => {
                      handleChangeInDescription(e.target.value, {
                        lang,
                        dataIndexItemDiscription: dataIndex,
                        text: 'listItemDescription',
                      })
                    }}
                    value={
                      dataItem[lang === 'En' ? 'listItemDescription' : 'listItemDescription_Te']
                    }
                    rows={8}
                    cols={50}
                  />
                </div>
              ))}
            </div>
            <div
              className='d-flex justify-content-center align-items-center'
              style={{ width: '10%' }}
            >
              <Button
                variant='danger'
                className='btn-sm mr-1 ml-1'
                onClick={() => DeleteItem(dataIndex)}
              >
                <i className='fa fa-times' />
              </Button>
              {dataIndex !== 0 && (
                <Button
                  variant='primary'
                  className='btn-sm mr-1 ml-1'
                  onClick={() => moveItemUp(dataIndex)}
                >
                  <i className='fa  fa-angle-double-up' />
                </Button>
              )}
              {dataIndex !== selectedMovieOrPersonData.length - 1 && (
                <Button
                  variant='primary'
                  className='btn-sm mr-1 ml-1'
                  onClick={() => moveItemDown(dataIndex)}
                >
                  <i className='fa  fa-angle-double-down	' />
                </Button>
              )}
            </div>
          </div>
          <label>Youtube Link</label>
          {dataItem.youtubeEmbedLink && (
            <div>
              <iframe
                key={dataItem.PK}
                width='320'
                height='240'
                src={dataItem.youtubeEmbedLink}
                title='YouTube video player'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              ></iframe>
              <button
                className='btn btn-danger removeVideoButton'
                disabled={!editIndexes.includes(dataItem.SK)}
                onClick={() => removeVideo(dataIndex)}
              >
                X
              </button>
              <button
                onClick={() => EditVideo(dataIndex)}
                className='btn btn-primary editVideoButton'
                disabled={!editIndexes.includes(dataItem.SK)}
              >
                <MdModeEditOutline />
              </button>
            </div>
          )}
          <YoutubeUrlComponent
            selectedListType={selectedListType}
            dataItem={dataItem}
            editIndexes={editIndexes}
            getURl={getURl}
            dataIndex={dataIndex}
            PushVideo={PushVideo}
          />
          <div>
            <div className='form-check'>
              <input
                checked={editIndexes.includes(dataItem.SK)}
                className='form-check-input'
                onChange={() => handleEdit(dataIndex, dataItem.SK)}
                type='checkbox'
                value=''
                id='editAbout'
              />
              <label
                className='form-check-label'
                htmlFor={`${dataItem.SK}`}
                onClick={() => handleEdit(dataIndex, dataItem.SK)}
              >
                Edit
              </label>
            </div>
          </div>
          <TaggedPerson
            movieTaggedPersons={
              editMode === 'edit'
                ? allTaggedPersons[0]
                  ? allTaggedPersons[0]
                  : []
                : allTaggedPersons[dataIndex]
                ? allTaggedPersons[dataIndex]
                : []
            }
            moviePersonId={dataItem.PK}
            personIndex={dataIndex}
            selectedListType={selectedListType}
            sendTaggedPersons={sendTaggedPersons}
            // addOrRemoveTaggedPerson={addOrRemoveTaggedPerson}
            taggedPersons={dataItem.taggedPersons ? dataItem.taggedPersons : []}
            editMode={editMode}
          />
        </div>
      ))}
    </>
  )
}

export default SelectedMoviePersonUi
